export default {
  redeemCode: {
    title: 'کوڈ ریڈیم کریں',
    description: 'اپنا انعام حاصل کرنے کے لیے نیچے اپنا ریڈیم کوڈ درج کریں۔',
    enterTip: 'انعامات حاصل کرنے کے لیے اپنا ریڈیم کوڈ درج کریں',
    label: 'ریڈیم کوڈ',
    placeholder: 'ریڈیم کوڈ درج کریں',
    submit: 'ریڈیم کریں',
    redeemBtn: 'ریڈیم کریں',
    submitting: 'ریڈیم ہو رہا ہے...',
    success: 'کوڈ کامیابی سے ریڈیم ہو گیا!',
    redeemSuccess: 'کوڈ کامیابی سے ریڈیم ہو گیا!',
    failed: 'کوڈ ریڈیم کرنے میں ناکام، براہ کرم دوبارہ کوشش کریں۔',
    redeemFailed: 'کوڈ ریڈیم کرنے میں ناکام، براہ کرم دوبارہ کوشش کریں۔'
  }
};
